import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'medium' }) => {
  const dimensions = {
    small: { width: 32, height: 32 },
    medium: { width: 48, height: 48 },
    large: { width: 64, height: 64 }
  };

  const { width, height } = dimensions[size];

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 100 100" 
      className={className}
      style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }}
    >
      {/* Background shield */}
      <defs>
        <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#002868" />
          <stop offset="50%" stopColor="#0047ab" />
          <stop offset="100%" stopColor="#1a1f3a" />
        </linearGradient>
        <linearGradient id="eagleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="50%" stopColor="#f8f9fa" />
          <stop offset="100%" stopColor="#e6f3ff" />
        </linearGradient>
        <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#bf0a30" />
          <stop offset="50%" stopColor="#dc3545" />
          <stop offset="100%" stopColor="#b91c3c" />
        </linearGradient>
        <linearGradient id="starGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffd700" />
          <stop offset="100%" stopColor="#ffed4a" />
        </linearGradient>
      </defs>

      {/* Shield background */}
      <path 
        d="M50 5 L85 20 L85 45 Q85 75 50 95 Q15 75 15 45 L15 20 Z" 
        fill="url(#shieldGradient)" 
        stroke="rgba(255,255,255,0.3)" 
        strokeWidth="1"
      />

      {/* Stylized eagle - simplified geometric form */}
      <g transform="translate(50, 35)">
        {/* Eagle body */}
        <ellipse cx="0" cy="8" rx="6" ry="12" fill="url(#eagleGradient)" />
        
        {/* Eagle wings */}
        <path 
          d="M-6 5 Q-18 0 -25 8 Q-20 12 -6 10 Z" 
          fill="url(#eagleGradient)" 
          opacity="0.9"
        />
        <path 
          d="M6 5 Q18 0 25 8 Q20 12 6 10 Z" 
          fill="url(#eagleGradient)" 
          opacity="0.9"
        />
        
        {/* Eagle head */}
        <circle cx="0" cy="-5" r="5" fill="url(#eagleGradient)" />
        
        {/* Eagle beak */}
        <path 
          d="M0 -8 L4 -6 L0 -4 Z" 
          fill="url(#accentGradient)"
        />
      </g>

      {/* Stars representing unity */}
      <g fill="url(#starGradient)">
        <path d="M25 25 L27 29 L31 29 L28 32 L29 36 L25 34 L21 36 L22 32 L19 29 L23 29 Z" />
        <path d="M75 25 L77 29 L81 29 L78 32 L79 36 L75 34 L71 36 L72 32 L69 29 L73 29 Z" />
        <path d="M50 15 L52 19 L56 19 L53 22 L54 26 L50 24 L46 26 L47 22 L44 19 L48 19 Z" />
      </g>

      {/* Scales of justice at bottom */}
      <g transform="translate(50, 75)" fill="url(#eagleGradient)">
        {/* Justice scale beam */}
        <rect x="-8" y="0" width="16" height="1" />
        {/* Left scale */}
        <path d="M-8 0 L-10 3 L-6 3 Z" />
        {/* Right scale */}
        <path d="M8 0 L10 3 L6 3 Z" />
        {/* Center post */}
        <rect x="-0.5" y="0" width="1" height="6" />
      </g>

      {/* Subtle stripes pattern overlay */}
      <g opacity="0.1">
        <rect x="15" y="30" width="70" height="2" fill="#bf0a30" />
        <rect x="15" y="35" width="70" height="2" fill="#bf0a30" />
        <rect x="15" y="40" width="70" height="2" fill="#bf0a30" />
      </g>
    </svg>
  );
};

export default Logo;